@if ((design$ | async) === 'classic') {
  <div class="fullscreen-wrapper">
    <div class="fullscreen-bg">
      <div class="overlay">
        <router-outlet></router-outlet>
        <button
          (click)="switchToClassicDesign()"
          class="profile-dropdown-item"
        >
          <fa-icon [icon]="['fas', 'rotate']" style="color: #3f5bf6"></fa-icon>
          <span>{{
              "menu.go_to_modern_design" | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="wrapper">
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-1.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-2.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-3.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-4.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-5.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-6.png" />
    </div>
    <div class="bool-wrapper">
      <img alt="bool" src="../../../assets/images/layout/dispersion-glass-7.png" />
    </div>

    <div class="overlay-new">
      <router-outlet></router-outlet>

      <div>
        <button
          (click)="switchToClassicDesign()"
          class="profile-dropdown-item"
        >
          <app-icon
            [color]="'#3f5bf6;'"
            [iconName]="['Arrows', 'rotate']"
            [icon]="['fas', 'rotate']"
            [size]="18"
          ></app-icon>
          <span>{{
              "profile_dropdown.SWITCH_TO_CLASSIC" | translate
            }}</span>
        </button>
      </div>
    </div>
  </div>
}
